import { Component } from '@angular/core';
import { CampaignSettingsAbstractComponent } from '../campaign-settings-abstract.component';
import {
  AutoResponder,
  AutoResponderTrigger,
  AutoResponderType,
  AutoResponderTypeLabels,
  Campaign,
  CampaignAutoResponderTrigger,
  CampaignAutoResponderTriggersList,
  CampaignSection,
  Pager,
} from '../../_models';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, AutoResponderService, CampaignService, LoaderService, SideNavService } from '../../_services';
import { FormBuilder } from '@angular/forms';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  templateUrl: './campaign-autoresponders.component.html',
  styleUrls: ['../campaign-section.scss', './campaign-autoresponders.component.scss'],
})
export class CampaignAutorespondersComponent extends CampaignSettingsAbstractComponent {
  public section = CampaignSection.Autoresponder;
  public autoresponders: AutoResponder[] = [];
  autoresponderConfig = false;
  selectedResponder: AutoResponder = null;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected campaignService: CampaignService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected modalService: NgxSmartModalService,
    protected sideNav: SideNavService,
    protected loaderService: LoaderService,
    protected autoresponderService: AutoResponderService
  ) {
    super(router, location, route, campaignService, sideNav, alertService, loaderService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      autoresponder_triggers: [],
    });
    super.ngOnInit();
  }

  onCampaignFetch(data: Campaign) {
    this.fetchAutoresponders();
    super.onCampaignFetch(data);
  }

  fetchAutoresponders() {
    this.loaderService.show();
    this.autoresponderService.list({}).subscribe((response: Pager) => {
      this.loaderService.hide();
      this.autoresponders = response.results.map((item: AutoResponder) => {
        return {
          ...item,
          trigger_types: this.campaign.autoresponder_triggers
            .filter((trigger) => trigger.autoresponder === item.id)
            .map((trigger) => trigger.trigger_type),
        };
      });
    }, error => {
      this.loaderService.hide();
      this.handleError(error)
    });
  }

  getAutoResponderTypeLabel(type: AutoResponderType) {
    return AutoResponderTypeLabels[type] || '';
  }

  getAutoResponderTriggerLabel(trigger: AutoResponderTrigger) {
    return CampaignAutoResponderTriggersList[trigger - 1] || '';
  }

  showListingPage() {
    this.autoresponderConfig = false;
    this.selectedResponder = null;
  }

  createNew() {
    this.autoresponderConfig = true;
    this.selectedResponder = null;
  }

  editAutoresponder(responder: AutoResponder) {
    this.autoresponderConfig = true;
    this.selectedResponder = responder;
  }

  updateAutoresponderTriggers(autoresponder_triggers: CampaignAutoResponderTrigger[]) {
    const currentTriggers = this.form.get('autoresponder_triggers').value || [];

    const autoresponder_id =
      autoresponder_triggers.length > 0
        ? autoresponder_triggers[0].autoresponder
        : this.selectedResponder && this.selectedResponder.id;

    // Set autoresponder to null for existing triggers with this autoresponder_id
    const triggersWithNulledAutoresponder = currentTriggers.map((trigger) =>
      trigger.autoresponder === autoresponder_id ? { ...trigger, autoresponder: null } : trigger
    );

    // If there are new triggers, add them. If not, just keep the array with nulled autoresponders
    const updatedTriggers =
      autoresponder_triggers.length > 0
        ? [...triggersWithNulledAutoresponder, ...autoresponder_triggers]
        : triggersWithNulledAutoresponder;

    this.form.patchValue({ autoresponder_triggers: updatedTriggers });
    this.onSubmit();
  }
}
